export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const SIGN_UP = 'SIGN_UP';
export const CONFIRM_CLIENT = 'CONFIRM_CLIENT';
export const SHOW_AUTH_POPUP = 'SHOW_AUTH_POPUP';
export const HIDE_AUTH_POPUP = 'HIDE_AUTH_POPUP';
export const SHOW_LOGOUT_POPUP = 'SHOW_LOGOUT_POPUP';
export const HIDE_LOGOUT_POPUP = 'HIDE_LOGOUT_POPUP';
export const ON_LOAD = 'ON_LOAD';

export const FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO';
export const SET_CLIENT_INFO = 'SET_CLIENT_INFO';
export const SET_CLIENT_AUTH_TOKEN = 'SET_CLIENT_AUTH_TOKEN';
export const SET_CLIENT_CONFIRM_PHONE = 'SET_CLIENT_CONFIRM_PHONE';
export const SET_CLIENT_BONUS_SCORE = 'SET_CLIENT_BONUS_SCORE';
